var React = require('react');
var PropTypes = React.PropTypes;
var auth = require('../../resources/auth');
import { browserHistory } from 'react-router';
import "../../css/components/Auth/login.css";

var Login = React.createClass({
  handleSubmit: function(e) {
    var _this = this;
    e.preventDefault();
    _this.setState({
      isLoading: true,
      loginError: false
    })
    var username = this.refs.emailInput.value,
        pw = this.refs.passwordInput.value;
    var loginObj = {
      username: username,
      password: pw
    }
    auth.login(loginObj, function(err, user) {
      _this.setState({
        isLoading: false
      })
      if (!err && user) {
        // var nextPath = _this.props.location.state.nextPathname;
        if (_this.props.location.state && _this.props.location.state.nextPathname) browserHistory.push(_this.props.location.state.nextPathname);
        else {
          var currentUser = auth.getCurrentUser();
          if (currentUser.status.indexOf('reviewer') >= 0) browserHistory.push('/review-tasks');
          else browserHistory.push('/students'); //"/collections"
        }
      } else {
        _this.setState({
          loginError: true
        })
      }
    })
  },

  getInitialState: function() {
    return {
      isLoading: false
    };
  },

  componentWillReceiveProps: function(nextProps) {

  },

  componentWillMount: function() {

  },

  render: function() {
    var _this = this;
    return (
      <div className="login-container">
        <h2>A-SLS</h2>
        <div className="section">
          <h3 className="section-title">Login</h3>
          <form className="form-horizontal" onSubmit={_this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="email" className="col-sm-2 control-label">UserName</label>
              <div className="col-sm-10">
                <input ref="emailInput" type="text" className="form-control" id="email" placeholder="Username or Email" required=""/>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="password" className="col-sm-2 control-label">Password</label>
              <div className="col-sm-10">
                <input ref="passwordInput" type="password" className="form-control" id="password" placeholder="Your password" required=""/>
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <button type="submit" className="btn">
                  {
                    _this.state.isLoading ?
                    <img src="https://cdn.zenquiz.net/static/Assets/loading-animation.gif" alt="Loading"/> :
                    <span>LOGIN</span>
                  }
                </button>
                {
                  _this.state.loginError && <div className="alert alert-danger margin-top-10" role="alert">Login fail. Please try again</div>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  },

  componentDidMount: function() {

  },

});

module.exports = Login;



/** WEBPACK FOOTER **
 ** ./src/components/Auth/Login.js
 **/